import React from "react";
import { PieChart, Pie, Tooltip, Legend, Cell } from "recharts";
import "./affinityStatusChart.css";
import "../../common/css/component.css";

const rootStyles = getComputedStyle(document.documentElement);
const colors = [
    rootStyles.getPropertyValue("--chart-color-1").trim(),
    rootStyles.getPropertyValue("--chart-color-2").trim(),
    rootStyles.getPropertyValue("--chart-color-5").trim(),
    rootStyles.getPropertyValue("--chart-color-4").trim(),
    rootStyles.getPropertyValue("--chart-color-3").trim(),
    rootStyles.getPropertyValue("--chart-color-6").trim(),
];

const preprocessAffinityList = (affinityList) => {
    // initialize counters
    let passedCount = 0;
    let portfolioCount = 0;
    let otherCount = 0;
  
    // count the occurrences
    affinityList.forEach((item) => {
      if (item.status === 'Passed') passedCount++;
      else if (item.status === 'Portfolio') portfolioCount++;
      else if (item.status === 'Closed') portfolioCount++;
      else otherCount++;
    });

    // Calculate total count
    const totalCount = passedCount + portfolioCount + otherCount;
  
    // create new array with the three categories and their percentages
    const processedAffinityList = [
      { status: 'Companies IC evaluated and decided to Pass', count: passedCount, percentage: ((passedCount / totalCount) * 100).toFixed(2) },
      { status: 'Companies we invested in', count: portfolioCount, percentage: ((portfolioCount / totalCount) * 100).toFixed(2) },
      { status: 'Other (Companies in various stages of evaluation)', count: otherCount, percentage: ((otherCount / totalCount) * 100).toFixed(2) },
    ];
  
    return processedAffinityList;
};

  

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p><span className="bold-label">Status:</span> {`${payload[0].payload.status}`}</p>
        <p><span className="bold-label">No. of Companies:</span> {`${payload[0].value}`}</p>
        <p><span className="bold-label">Percentage:</span> {`${payload[0].payload.percentage}%`}</p>
      </div>
    );
  }
  return null;
};

const CustomLegend = ({ payload, data }) => {
    return (
      <div className="custom-legend">
        {
          payload.map((entry, index) => (
            <div key={`item-${index}`} className="custom-legend-item" >
              <span style={{backgroundColor: entry.color}}></span>
              {data[index].status}
            </div>
          ))
        }
      </div>
    );
  };


const AffinityStatusChart = ({ affinityList }) => {
  if (!Array.isArray(affinityList)) {
    return <div>No data available.</div>;
  }

  // Prepare the data
  const data = preprocessAffinityList(affinityList);
  return (
    <div className="component-container-no-border">
      <PieChart width={400} height={400} style={{ marginTop: '10px'}}>
        <Pie
          dataKey="count"
          isAnimationActive={true}
          data={data}
          cx="50%"
          cy="50%"
          outerRadius={150}
          innerRadius={100} 
          fill={colors[0]}
          labelLine={false}
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)
          }
          <Legend />
        </Pie>
        <g>
            <text x={200} y={210} textAnchor="middle" dominantBaseline="middle" className="donut-center-text">
              Investment Percentage
            </text>
            <text x={200} y={230} textAnchor="middle" dominantBaseline="middle" className="donut-center-text bold-italic">
              {data[1].percentage + '%'}
            </text>
            <text x={200} y={260} textAnchor="middle" dominantBaseline="middle" className="donut-center-text">
              Out of <tspan className="bold-italic">{data[0].count + data[1].count + data[2].count}</tspan> companies.
            </text>
          </g>
        <Tooltip content={<CustomTooltip />} />
        <Legend 
            wrapperStyle={{ marginBottom: '100px' }} 
            content={<CustomLegend data={data} />}
            layout="horizontal"
            align="center"
            verticalAlign="top"
        />
      </PieChart>
    </div>
  );
};

export default AffinityStatusChart;
